import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({children}) => {
  const token  = useSelector(state => state.auth.token);
  return (token ? children : <Navigate to="/login" />)
}

export {ProtectedRoute};